import { ClientLocal } from "app/api/types";

export const updateNotificationStatus = (chats: ClientLocal[], payload: ClientLocal, value: boolean) => {
	const client = chats.find(x => x.companionId === payload.companionId);
	if (!client) return chats;

	client.isTyping = value;
	return [...chats];
}
